export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "dating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date"])},
        "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date"])},
        "from": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["from"])},
        "to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["to"])}
      },
      "de": {
        "dating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datierung"])},
        "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datum"])},
        "from": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ab"])},
        "to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bis"])}
      }
    }
  })
}
